import * as z from "zod";
import {CustomerManagementResModel} from "./CustomerManagementResModel";

const schema = z.object({
	list: z.array(CustomerManagementResModel.model).default([])
});

const model = schema.transform((values) => ({
	...values
}));

export const CustomerManagementListResModel = {schema, model};
export type ICustomerManagementListResModel = z.infer<typeof CustomerManagementListResModel.model>;
export const DEFAULT_CUSTOMER_MANAGEMENT_LIST_RES: ICustomerManagementListResModel = {
	list: []
};
